import React, { useState } from 'react';
import DeviceManager from './Developer/DeviceManager';
import CertificateManager from './Developer/CertificateManager';
import ProfileManager from './Developer/ProfileManager';
import BundleManager from './Developer/BundleManager';

function DeveloperSection() {
  const [activeTab, setActiveTab] = useState('devices');

  const tabs = [
    { id: 'devices', label: 'Devices', icon: '📱' },
    { id: 'certificates', label: 'Certificates', icon: '📜' },
    { id: 'profiles', label: 'Profiles', icon: '🔐' },
    { id: 'bundles', label: 'Bundle IDs', icon: '📦' }
  ];

  return (
    <div className="content-main">
      <div className="section-header">
        <h1 className="section-title">⚙️ Developer Resources</h1>
        <p className="section-description">Manage your development certificates, devices, and provisioning profiles</p>
      </div>

      <div className="tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span style={{ marginRight: '8px' }}>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className="animate-slideUp">
        {activeTab === 'devices' && <DeviceManager />}
        {activeTab === 'certificates' && <CertificateManager />}
        {activeTab === 'profiles' && <ProfileManager />}
        {activeTab === 'bundles' && <BundleManager />}
      </div>
    </div>
  );
}

export default DeveloperSection;
